import { VueReCaptcha } from '../../vue-recaptcha-v3/ReCaptchaVuePlugin'

export default defineNuxtPlugin((nuxtApp) => {
  const { public: config } = useRuntimeConfig()

  if (config.recaptchaSiteKey) {
    nuxtApp.vueApp.use(VueReCaptcha, {
      siteKey: config.recaptchaSiteKey,
      loaderOptions: { autoHideBadge: true },
    })
  }
})
